import { Component, input, model, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
@Component({
    selector: 'app-season-base-form-header',
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './season-base-form-header.component.html'
})
export class SeasonBaseFormHeaderComponent {
    public readonly enableIcon = input<boolean>(false);
    public readonly translationKey = input<string>('');
    public isDisabled = model<boolean>(false);
}
